/* @flow */

export default {
  root: {
    width: 29,
    height: 27,
  },
};
